import React from 'react';

/**
 * Section-level error fallback for individual panels (Chart, AI, Notes, etc.).
 * Shows a compact inline recovery card instead of crashing the whole lab.
 *
 * Props:
 *   - error: The caught Error object
 *   - reset: Function to reset the error boundary and retry
 *   - name: Optional name of the section that failed
 */
function SectionErrorFallback({ error, reset, name }) {
  const isDev = process.env.NODE_ENV === 'development' ||
    (typeof window !== 'undefined' && window.location.hostname === 'localhost');

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 16px',
      textAlign: 'center',
      backgroundColor: 'var(--card, #2a2a2a)',
      border: '1px solid var(--border, #444)',
      borderRadius: 'var(--radius, 8px)',
      margin: '8px',
      minHeight: '80px'
    }}>
      <p style={{
        margin: '0 0 4px 0',
        fontSize: '14px',
        fontWeight: 600,
        color: 'var(--foreground, #e8e0d8)'
      }}>
        {name ? `${name} encountered an error` : 'This section encountered an error'}
      </p>

      {isDev && (
        <p style={{
          margin: '0 0 12px 0',
          fontSize: '12px',
          color: 'var(--destructive, #ef4444)',
          maxWidth: '300px',
          wordBreak: 'break-word'
        }}>
          {error.message}
        </p>
      )}

      <button
        onClick={reset}
        style={{
          marginTop: isDev ? '0' : '12px',
          padding: '6px 16px',
          backgroundColor: 'var(--primary, #2563eb)',
          color: 'var(--primary-foreground, #fff)',
          border: 'none',
          borderRadius: 'var(--radius, 6px)',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 500,
          transition: 'opacity 0.2s'
        }}
        onMouseOver={(e) => e.target.style.opacity = '0.85'}
        onMouseOut={(e) => e.target.style.opacity = '1'}
      >
        Retry
      </button>
    </div>
  );
}

export default SectionErrorFallback;
